export default {
  title: 'Artículos agotados',
  sections: {
    settings: 'Configuración',
  },
  fields: {
    has_sold_out_items_auto_reset: {
      options: {
        auto_reset: 'Los artículos agotados se marcan automáticamente como disponibles al final del día.',
        manual_reset:
          'El personal debe marcar los artículos como disponibles después de haberlos marcado como agotados.',
      },
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar cambios',
    changes_got_saved: 'Cambios guardados',
  },
};
